import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

@observer
class SearchCarModal extends Component {
  state = {
    timer: 0
  }

  intervalRef = null
  intervalRefChkOrderStatus = null

  componentDidMount(){
    this.setState({
      timer: (this.props.timeToEnd - Math.round(Date.now()/1000))
    }, () => {
      this.intervalRef = setInterval(() => this.setState({timer: this.state.timer - 1}), 1000)
      this.intervalRefChkOrderStatus = setInterval(() => {
        if(this.state.timer < 1){
          clearInterval(this.intervalRef)
          clearInterval(this.intervalRefChkOrderStatus)
        } else {
          this.props.chkOrderStatus()
        }
      }, 1000)
    })
  }

  componentWillUnmount(){
    clearInterval(this.intervalRef)
    clearInterval(this.intervalRefChkOrderStatus)
  }
  
  render() {
    const orderRoute = this.props.selectedStreet.map( (street, i) => {
      return (<p key={`${street}-${this.props.selectedHouse[i]}`}>{street} {this.props.selectedHouse[i]}</p>)
    })
 
    return (
      <div className="car_ordering_items">
        <div className="top_row">
          <button className="order_items"><i className="btn-toggle__icon--order close"></i></button>
          <div className="search_car">
            <span>Идет поиск автомобиля</span>
          </div>
        </div>
        <div className="rows">
          <div className="middle_row">
            <i className="icon"></i>
            <div className="streets">
              {orderRoute}
            </div>
          </div>
          <div className="bottom_row">
            <button className="btn-cancel" id="order-module-cancel-btn-stage-1" onClick={this.props.cancelOrder}>
              <i className="btn-cancel__icon"></i>
              <span>Отменить заказ</span>
            </button>
          </div>
          <div className="right_column">
            <div className="waiting_time">
              <span>00:{this.state.timer}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const withData = inject(stores => ({
  selectedStreet: stores.OrderStore.selectedStreet,
  selectedHouse: stores.OrderStore.selectedHouse,
  timeToEnd: stores.OrderStore.timeToEnd,
  cancelOrder: stores.OrderStore.cancelOrder,
  chkOrderStatus: stores.OrderStore.chkOrderStatus,
}))

export default withData(SearchCarModal);
